import { $$ } from '../../utilities/QuerySelectors.js';

class SourcesAccordion
{
    constructor(container = null) {
        this.container = container ? container : document.querySelector('#sources');
        this.status = this.container ? this.container.getAttribute('data-state') : null;
    }

    toggleStatus() {
        this.container.setAttribute('data-state', this.container.getAttribute('data-state') === 'collapsed' ? 'expanded' : 'collapsed');
    }

    toggleBody() {
        jQuery(this.container).find('.evergreen__sources__body-js').slideToggle();
    }

    toggle() {
        if (this.container === null) {
            return;
        }
        this.toggleStatus();
        this.toggleBody();
    }

    expand() {
        if (this.status === 'collapsed') {
            this.toggle();
        }
    }

    collapse() {
        if (this.status === 'expanded') {
            this.toggle();
        }
    }
}

function initSourcesAccordion()
{
    $$(".evergreen__sources__title-js").forEach(title => {
        title.addEventListener('click', () => {
            (new SourcesAccordion(title.parentElement)).toggle();
        });
    });

    window.addEventListener('hashchange', () => {
        if (window.location.hash === '#sources') {
            (new SourcesAccordion()).expand();
        }
    });

    if (window.location.hash === '#sources') {
        (new SourcesAccordion()).expand();
    }
}

export function initEvergreen()
{
    if ('jQuery' in window) {
        // @ts-ignore: jQuery is in window
        jQuery(document).ready(function(){
            initSourcesAccordion();
        });
    }
}
